export default "__VITE_ASSET__BCQI_Hl6__"